import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import "./login.scss";

const Loginscreen = () => {
  const [password, setPassword] = useState("");
  const [isTouched, setIsTouched] = useState(false);
  const [isError, setIsError] = useState(false);
  const history = useHistory();

  useEffect(() => {
    // if already logged in, redirect to home
    if (localStorage.getItem("authPassword") === "Quecko@123!") {
      history.replace("/"); // ✅ replace so no back button
    }
  }, [history]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setPassword(value);

    // clear error if field becomes empty
    if (value === "") {
      setIsError(false);
    }
  };

  const handleContinue = () => {
    if (password === "Quecko@123!") {
      localStorage.setItem("authPassword", password);
      window.location.href = "/"; //immediately redirect
    } else {
      setIsError(true);
    }
  };

  return (
    <>
      <div className="mainlogindiv">
            <div className="mainlogo">
            <img src="\logo.svg" alt="Logo" />
          </div>
        <section className="loginmain">
          <video
            className="main-banner-video"
            muted="muted"
            playsinline="playsinline"
            autoPlay
            loop
            width="100%"
            id="myVideo"
          >
            <source src="/loginvideo.mp4" type="video/mp4" />
          </video>

      

          <div className="innerlogin">
            <h1 className="loginhead">Enter password to continue</h1>

            <div className="inputmain">
              <h6 className="inputpara">Password</h6>
              <input
                placeholder="Enter your password"
                type="password"
                value={password}
                onChange={handleInputChange}
                onFocus={() => setIsTouched(true)}
                onBlur={() => setIsTouched(false)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleContinue();
                  }
                }}
                className={`innerinput
    ${isTouched ? "activeborder" : ""}
    ${isError ? "errorborder" : ""}
  `}
              />

              {isError && <p className="errorpara">Invalid Password</p>}
            </div>

            <div className="bottombtn">
              <button
                className={`continuebtn ${
                  password === "" ? "disabledbtn" : ""
                }`}
                onClick={handleContinue}
                disabled={password === ""}
              >
                Continue
              </button>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Loginscreen;
